import React from 'react';
import { ConfirmOrder } from './ConfirmOrder';
import { InvalidQR } from './InvalidQR';
import { MenuList } from './MenuList';
import { Order } from './Order';
import { OrderSummary } from './OrderSummary';
import { PatronOrderGuard } from './PatronOrderGuard';
import { Payment } from './Payment';
import { QRRedirect } from './QRRedirect';
import { Receipt } from './Receipt';
import { FiuuPaymentReturn } from './FiuuPaymentReturn';

const withPatronOrderGuard = (component: React.ReactNode) => (
	<PatronOrderGuard>{component}</PatronOrderGuard>
);

const orderRoutes = [
	{
		props: {
			exact: true,
			path: '/menu/patron-app/outlet/:outletID/qr-code/:qrID/:accountID',
		},
		component: <QRRedirect />,
	},
	{
		props: {
			exact: true,
			path: '/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID',
		},
		component: withPatronOrderGuard(<MenuList />),
	},
	{
		props: {
			exact: true,
			path:
				'/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID/menu-category/:menuID',
		},
		component: withPatronOrderGuard(<Order />),
	},
	{
		props: {
			exact: true,
			path:
				'/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID/menu-category/:menuID/summary',
		},
		component: withPatronOrderGuard(<OrderSummary />),
	},
	{
		props: {
			exact: true,
			path:
				'/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID/menu-category/:menuID/summary/confirm-order',
		},
		component: withPatronOrderGuard(<ConfirmOrder />),
	},
	{
		props: {
			exact: true,
			path:
				'/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID/menu-category/:menuID/summary/confirm-order/payment',
		},
		component: withPatronOrderGuard(<Payment />),
	},
	{
		props: {
			exact: true,
			path:
				'/menu/patron-app/outlet/:outletID/table/:tableID/order/:orderID/menu-category/:menuID/summary/confirm-order/payment/:billID/receipt',
		},
		component: <Receipt />,
	},
	{
		props: { exact: true, path: '/menu/patron-app/fiuu-payment-return' },
		component: <FiuuPaymentReturn />,
	},
	{
		props: { exact: true, path: '/menu/patron-app/invalid-qr' },
		component: <InvalidQR />,
	},
];

export default orderRoutes;
